<template>
  <form-fieldset :class="isAlternativeMethodSupported && 'section section--half-y-padding section--no-border'">
    <div
      v-if="isLoading"
      class="spacing-top"
    >
      <div class="loader" />
    </div>

    <methods-radio-buttons
      v-else-if="giftCardReloadPaymentMethod && (isGooglePayEnabled || isApplePayEnabled)"
      :can-use-google-pay="isGooglePayEnabled"
      :can-use-apple-pay="isApplePayEnabled"
      :force-show-apple-pay="giftCardReloadPaymentMethod.method === 'ApplePay'"
      :selected-payment-method="selectedPaymentMethod"
      @method-select="$emit('method-select', $event)"
    />

    <div
      v-show="!isLoading && !giftCardReloadPaymentMethod"
    >
      <!--
      Previously only ShiftFour methods were being hidden when the `simplePayment` prop was true.
      I have no idea why, so this is something we should look out for.
      -->
      <methods-shift-four
        v-if="paymentGateway.providers['ShiftFour']"
        v-bind="{ ...$props, ...$attrs }"

        @set-loading-status="setLoadingStatus"
        @set-enabled-payment-method="setEnabledPaymentMethod"
      />

      <methods-square
        v-else-if="paymentGateway.providers['Square']"
        ref="alternativeMethods"
        v-bind="{ ...$props, ...$attrs }"

        @set-loading-status="setLoadingStatus"
        @set-enabled-payment-method="setEnabledPaymentMethod"
      />

      <methods-standard
        v-else
        ref="alternativeMethods"
        v-bind="{ ...$props, ...$attrs }"

        @set-loading-status="setLoadingStatus"
        @set-enabled-payment-method="setEnabledPaymentMethod"
      />
    </div>

    <div
      v-if="paymentGateway.methods.creditCard && isAlternativeMethodSupported"
      class="title-separator no-spacing spacing-top"
    >
      <p class="title title--6 uppercase">
        or
      </p>
    </div>
  </form-fieldset>
</template>

<script>
  import MethodsRadioButtons from './methods-radio-buttons.vue';
  import MethodsShiftFour from './methods-shift-four.vue';
  import MethodsSquare from './methods-square.vue';
  import MethodsStandard from './methods-standard.vue';

  export default {
    name: 'AlternativePaymentMethods',

    components: {
      MethodsRadioButtons,
      MethodsShiftFour,
      MethodsSquare,
      MethodsStandard
    },

    props: {
      giftCardReloadPaymentMethod: {
        type: [Object, Boolean],
        default: null
      },

      hiddenElements: {
        type: Object,
        default: () => ({})
      },

      paymentGateway: {
        type: Object,
        required: true
      },

      selectedPaymentMethod: {
        type: String,
        required: true
      },

      showGiftCardButton: {
        type: Boolean,
        default: false
      },

      showRoomChargeButton: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        isLoading: true,
        isApplePayEnabled: false,
        isGooglePayEnabled: false
      };
    },

    computed: {
      isAlternativeMethodSupported() {
        return this.isApplePayEnabled || this.isGooglePayEnabled || this.showGiftCardButton || this.showRoomChargeButton;
      }
    },

    methods: {
      setLoadingStatus(loadingStatus) {
        this.isLoading = loadingStatus;
      },

      setEnabledPaymentMethod(methodType) {
        if (methodType === 'apple-pay') this.isApplePayEnabled = true;

        if (methodType === 'google-pay') this.isGooglePayEnabled = true;
      }
    }
  };
</script>
